<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="24"
		viewBox="0 0 22 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.0004 3.83594C11.3801 3.83594 11.6879 4.17172 11.6879 4.58593L11.688 11.2501H17.7968C18.1765 11.2501 18.4843 11.5859 18.4843 12.0001C18.4843 12.4143 18.1765 12.7501 17.7968 12.7501H11.688L11.6879 19.4143C11.6879 19.8285 11.3801 20.1643 11.0004 20.1643C10.6207 20.1643 10.3129 19.8285 10.3129 19.4143L10.313 12.7501L4.2041 12.7501C3.82441 12.7501 3.5166 12.4143 3.5166 12.0001C3.5166 11.5859 3.82441 11.2501 4.2041 11.2501L10.313 11.2501L10.3129 4.58594C10.3129 4.17173 10.6207 3.83594 11.0004 3.83594Z"
			fill="white"
		/>
	</svg>
</template>
